const LOCAL_STORAGE_KEY = 'sber-speech';
const COOKIE_KEY = 'speechId';
export const DEFAULT_TOOLTIP = {
    gap: '18px',
    position: 'bottom',
};
export function getUserIdCookie() {
    const matches = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_KEY.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
export function setUserIdCookie() {
    const maxAge = 7 * 24 * 60 * 60;
    const newId = `${(Math.random() * 100000000).toFixed(0)}`;
    document.cookie = `${encodeURIComponent(COOKIE_KEY)}=${encodeURIComponent(newId)}; Path=/; Max-Age=${maxAge};`;
    return newId;
}
function getLocalStorage(key = LOCAL_STORAGE_KEY) {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : data;
}
function setLocalStorage(key = LOCAL_STORAGE_KEY) {
    localStorage.setItem(key, JSON.stringify((Math.random() * 100000000).toFixed(0)));
}
export function hasSpeechUserId() {
    if (getLocalStorage()) {
        return true;
    }
    setLocalStorage();
    return false;
}
